<template>
  <div class="dsf-ac-style-coursebox">
    <grid
      ref="dsfDatagrid"
      :demo="demo"
      :hasLoad="hasLoad"
      :hasRefresh="hasRefresh"
      :http-param="childform"
      :background-color="'#fff'"
      :limit="limit"
      :padding="padding"
      style="height:100%">
      <div slot="default" slot-scope="sditem" :key="sditem.data._id">
        <div class="citem" @click="tocou(sditem.data._id)">
          <div class="imgbox">
            <van-image :src="setImg(sditem.data)" fit="full" :width="'100%'" :height="'100%'">
              <template v-slot:loading>
                <van-loading type="spinner" size="20" />
              </template>
              <template v-slot:error>
                <img :src="require('_teas/assets/styles/themes/img/file-read-18688.png')" style="width:100%;height:100%">
              </template>
            </van-image>
            <div class="tnum ds_font8">
              <i></i><span>{{sditem.data['nc_kck_zxkc_zxkcsjy.kcsc']}}</span>
            </div>
            <h6></h6>
            <h5>{{sditem.data['nc_kck_zxkc_zxkcsjy.kcfs']}}</h5>
          </div>
          <div class="rcontent">
            <div class="toptitle ds_font5_m">
              <span v-if="sditem.data['nc_kck_zxkc_zxkcsjy.sfnew'] == 1" class="s1 ds_font8">new</span>
              <span v-if="sditem.data['nc_kck_zxkc_zxkcsjy.sfbx'] == 1" class="s2 ds_font6">必修</span>
              <p class="ell2">{{sditem.data['nc_kck_zxkc_zxkcsjy.title']}}</p>
            </div>
            <div class="cencontent ds_font8 ell">
              {{sditem.data["nc_kck_zxkc_zxkcsjy.skjs"]}}
            </div>
            <div class="footnum ds_font8">
              <p class="p1">
                <dsf-icon name="icon_yulan" /><span>{{sditem.data["nc_kck_zxkc_zxkcsjy.ckl"]}}</span>
              </p>
              <p class="p2">
                <dsf-icon name="date" /><span>{{sditem.data["nc_kck_zxkc_zxkcsjy.kcxs"]}}学时</span>
              </p>
            </div>
            <div class="rechart">
              <van-circle :value="recharNum(sditem.data)" :text="sditem.data['nc_kck_zxkc_zxkcsjy.wcjd']" layer-color="#D8D8D8" color="#FF6A00" :rate="sditem.data['nc_kck_zxkc_zxkcsjy.wcjd']" :speed="30" :size="pxToRem('35px')" :stroke-width="100" />
            </div>
          </div>

        </div>
      </div>
    </grid>
  </div>
</template>

<script>
import grid from "./oldGrid";
const demo = [
  {
    "nc_kck_zxkc_zxkcsjy.ds_update_time": "2021-02-02 10:38:14",
    "nc_kck_zxkc_zxkcsjy.kcsc": "00:46:53",
    "nc_kck_zxkc_zxkcsjy.sfbx": 0,
    "nc_kck_zxkc_zxkcsjy.title": "党在现阶段的奋斗目标(kc)",
    "nc_kck_zxkc_zxkcsjy.dzl": "0",
    "nc_kck_zxkc_zxkcsjy.kcfs": "0.0",
    "nc_kck_zxkc_zxkcsjy.skjs": "郝建-贵州省委组织部教研部教授、副主任",
    "nc_kck_zxkc_zxkcsjy.ckl": 284,
    "nc_kck_zxkc_zxkcsjy.sfwc": "0",
    "nc_kck_zxkc_zxkcsjy.xxsj": "2021-02-02 10:38:14",
    "nc_kck_zxkc_zxkcsjy.pxrq_sdate": null,
    "nc_kck_zxkc_zxkcsjy.sfnew": 0,
    "nc_kck_zxkc_zxkcsjy.kcxs": 1.5,
    "nc_kck_zxkc_zxkcsjy.sfxx": "0",
    "nc_kck_zxkc_zxkcsjy.cover":
      '[{"originalFileName":"党在现阶段的奋斗目标.jpg","name":"党在现阶段的奋斗目标","suffix":"jpg","size":49431,"contentType":"application/octet-stream","relativePath":"/upload/files/20201103/dd589a94918348828db6453faca36eca.jpg","absolutePath":"http://61.243.3.22:8088/dsfa/upload/files/20201103/dd589a94918348828db6453faca36eca.jpg","uploadDate":"2020-11-03 17:23:32","id":"1b1e6850e5c048c58916a912ec35dd54"}]',
    "nc_kck_zxkc_zxkcsjy.code": "KC2000104",
    "nc_kck_zxkc_zxkcsjy.pxrq_edate": null,
    "nc_kck_zxkc_zxkcsjy.wcjd": "67",
    _id: "803427e6924e4b8d831be2a21f84c85f"
  },
  {
    "nc_kck_zxkc_zxkcsjy.ds_update_time": "2021-02-02 10:38:11",
    "nc_kck_zxkc_zxkcsjy.kcsc": "00:05:47",
    "nc_kck_zxkc_zxkcsjy.sfbx": 0,
    "nc_kck_zxkc_zxkcsjy.title": "颂红船精神：开启敢为人先密钥（附加考试3次）",
    "nc_kck_zxkc_zxkcsjy.dzl": "0",
    "nc_kck_zxkc_zxkcsjy.kcfs": "3.5",
    "nc_kck_zxkc_zxkcsjy.skjs": "郝建-贵州省委组织部教研部教授、副主任",
    "nc_kck_zxkc_zxkcsjy.ckl": 316,
    "nc_kck_zxkc_zxkcsjy.sfwc": "1",
    "nc_kck_zxkc_zxkcsjy.xxsj": "2021-02-02 10:38:11",
    "nc_kck_zxkc_zxkcsjy.pxrq_sdate": null,
    "nc_kck_zxkc_zxkcsjy.sfnew": 0,
    "nc_kck_zxkc_zxkcsjy.kcxs": 0.5,
    "nc_kck_zxkc_zxkcsjy.sfxx": "0",
    "nc_kck_zxkc_zxkcsjy.cover":
      '[{"originalFileName":"12.jpg","name":"12","suffix":"jpg","size":45954,"contentType":"application/octet-stream","relativePath":"/upload/files/20201022/5dac8287c68a4762ad887569131bb402.jpg","absolutePath":"http://61.243.3.22:8088/dsfa/upload/files/20201022/5dac8287c68a4762ad887569131bb402.jpg","uploadDate":"2020-10-22 09:56:10","id":"65b3fb3b386a456aa31a29f09b7e2b54"}]',
    "nc_kck_zxkc_zxkcsjy.code": "KC2000097",
    "nc_kck_zxkc_zxkcsjy.pxrq_edate": null,
    "nc_kck_zxkc_zxkcsjy.wcjd": "100",
    _id: "c29bdc0597284b5b9d54d002679fd5cf"
  }
];

export default {
  name: "inlearningCourse",
  props: {
    childform: {
      type: Object,
      default() {
        return {};
      }
    },
    limit: {
      type: Number,
      default: 9
    },
    hasLoad: {
      type: Boolean,
      default: true,
      desc: "是否有上拉加载"
    },
    hasRefresh: {
      type: Boolean,
      default: true,
      desc: "是否有下拉刷新"
    },
    padding: {
      type: Array,
      default() {
        return [0, 15, 0, 15];
      }
    }
  },
  components: {
    grid
  },
  data() {
    return {
      currentRate: 30,
      isLoading: false,
      loading: false,
      finished: false,
      demo: []
    };
  },
  computed: {},
  created: function () {
    this.demo = demo;
  },

  methods: {
    setImg(data) {
      let cover = data["nc_kck_zxkc_zxkcsjy.cover"];
      if (cover) {
        cover = dsf.url.getWebPath(JSON.parse(cover)[0]["relativePath"]);
      }
      return cover || "/";
    },
    recharNum(data) {
      let wcjd = data["nc_kck_zxkc_zxkcsjy.wcjd"];
      wcjd = wcjd * 1;
      return wcjd;
    },
    tocou(id) {
      if (this.isDesign) return;
      this.$router.push({
        path: "/mobile/nc/recommendFile/mobile-courseDetail?id=01d6546579414e62b9c927bf1bde83f0"
        // path:"/iframeloader?src="+encodeURIComponent(`${location.origin}/dsfa_nc/nc/mobile/dist/webmobile/index.html#/player/${id}/2`)
      });
      // this.$router.push({ "path": "/player/" + id + "/2" })
      // this.$open({ url: `${location.origin}/dsfa_nc/nc/mobile/dist/webmobile/index.html#/player/${id}/2`, state: 4 });
    },
    reset() {
      this.$refs.dsfDatagrid.query();
    }
  }
};
</script>
